
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/separation-anxiety-elementary-school",
      function () {
        return require("private-next-pages/blog/separation-anxiety-elementary-school.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/separation-anxiety-elementary-school"])
      });
    }
  